/**
 * Complete Meeting Task API
 * Feature: 019-build-a-framework
 */

import axiosInstance from '../axiosInstance';

export interface CompleteMeetingTaskRequest {
  enrollmentId: number;
  completedByUserId: number;
  meetingScheduledFor?: string; // ISO 8601 date
  notes?: string;
}

export interface CompleteMeetingTaskResponse {
  completed: boolean;
  completedAt: string;
  taskData: {
    meetingScheduledFor?: string;
    notes?: string;
  };
}

export const completeMeetingTask = async (
  pathItemId: number,
  request: CompleteMeetingTaskRequest
): Promise<CompleteMeetingTaskResponse> => {
  const response = await axiosInstance.post<CompleteMeetingTaskResponse>(
    `/api/path-items/${pathItemId}/complete-meeting-task`,
    request
  );

  return response.data;
};
